import {MessagingRole} from 'Users/models/User/MessagingUserType';

export class ManagerUserType {
  public readonly key = 'ManagerUserType';
  public readonly messagingRole = MessagingRole.Manager;
}
